import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "mo_token";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Cross-site fallback: when the app is served from a custom domain (es. www.menuone.it)
// browsers block the third-party session cookie, so we also send the token as Bearer.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const uiLang = localStorage.getItem("menuone_ui_lang") || "it";
  config.headers["X-UI-Lang"] = uiLang;
  return config;
});

export const saveToken = (token) => { if (token) localStorage.setItem(TOKEN_KEY, token); };
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export function fileUrl(path) {
  if (!path) return null;
  return `${API}/files/${path}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
